import React, { memo, useRef } from 'react'
import ReactPlayer from 'react-player'
import { Icon } from 'antd'

const VideoPlayer = ({ url, isVisible }) => {
  const playerRef = useRef(null)

  if (!isVisible) {
    return (
      <div
        style={{
          width: '100%',
          height: '250px',
          backgroundColor: '#f0f0f0',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: '#999'
        }}
      >
        <Icon type="play-circle" style={{ fontSize: '48px' }} />
      </div>
    )
  }

  return (
    <div style={{ width: '100%', height: '250px' }}>
      <ReactPlayer
        ref={playerRef}
        url={url}
        width="100%"
        height="250px"
        controls={true}
        playing={false}
        config={{
          file: {
            attributes: {
              controlsList: 'nodownload',
              preload: 'metadata'
            }
          }
        }}
      />
    </div>
  )
}

// CRITICAL: Only re-render VideoPlayer if URL or visibility changes
export default memo(VideoPlayer, (prevProps, nextProps) => {
  return (
    prevProps.url === nextProps.url &&
    prevProps.isVisible === nextProps.isVisible
  )
})
